import { cameras } from '../view/cameras';
import { lang } from '../lang';
import { historie } from '../history';
import { project } from '../projects/project';
import { beads } from '../beads';
import { settings } from '../settings';
import { menu } from '../menu';
import { modes } from '../modes';
import { save } from '../projects/save';
import { panelTools } from './panels';

const topTools = [
    {
        name: 'Menu', canFocus: true, texture: 'menu',
        tip: lang.get('menu tool tip', 'Menu'), disabled: false,
        onClick: () => {
            menu.show();
        }
    },
    {
        name: 'Draw', canFocus: true, texture: 'draw',
        tip: lang.get('draw tool tip', 'Draw Tool') + ' (D)', disabled: false,
        onClick: () => {
            modes.start('draw');
        }
    },
    {
        name: 'Erase', canFocus: true, texture: 'erase',
        tip: lang.get('erase tool tip', 'Erase Tool') + ' (E)', disabled: false,
        onClick: () => {
            modes.start('erase');
        }
    },
    {
        name: 'Hand', canFocus: true, texture: 'hand',
        tip: lang.get('hand tool tip', 'Hand Tool') + ' (H)', disabled: false,
        onClick: () => {
            modes.start('hand');
        }
    },
    {
        name: 'Rotator', canFocus: true, texture: 'rotate',
        tip: lang.get('rotate tool tip', 'Rotate Tool'), disabled: false,
        onClick: () => {
            modes.start('rotate');
        }
    },
    {
        name: 'Cloud', canFocus: false, texture: 'cloud',
        tip: lang.get('save tool tip', 'Save to cloud'), disabled: false,
        hideInFreeVersion: true,
        onClick: () => {
            save.currentlyOpenFile();
        }
    },
    {
        name: 'Palette', canFocus: true, texture: 'palette',
        tip: lang.get('open color pickers tool tip', 'Open Color Pickers'), disabled: false,
        onClick: () => {
            modes.start('editSwatch');
        }
    },
    {
        name: 'Bead Library', canFocus: true, texture: 'chest',
        tip: lang.get('bead library tool tip', 'Bead Library'), disabled: false,
        onClick: () => {
            if (b3.store.state.showingModal !== 'library-modal') {
                modes.start('input');
            }
        }
    },
    {
        name: 'Zoom In', canFocus: false, texture: 'zoom_in',
        tip: lang.get('zoom in tool tip', 'Zoom in') + ' (+)', disabled: false,
        onClick: () => cameras.zoomIn()
    },
    {
        name: 'Zoom Out', canFocus: false, texture: 'zoom_out',
        tip: lang.get('zoom out tool tip', 'Zoom out') + ' (-)', disabled: false,
        onClick: () => cameras.zoomOut()
    },
    {
        name: 'Undo', canFocus: false, texture: 'undo',
        tip: lang.get('undo tool tip', 'Undo') + ' (Alt + Z)', disabled: false,
        onClick: () => {
            historie.undo();
            beads.unselectAll();
        }
    },
    {
        name: 'Redo', canFocus: false, texture: 'redo',
        tip: lang.get('redo tool tip', 'Redo'), disabled: false,
        onClick: () => {
            historie.redo();
            beads.unselectAll();
        }
    },
    {
        name: 'Share', canFocus: true, texture: 'camera',
        tip: lang.get('screenshot tool tip', 'Share a screenshot'), disabled: false,
        onClick: () => {
            project.screenshot();
        }
    },
    {
        name: 'Marquee', canFocus: true, texture: 'marquee',
        tip: lang.get('marquee tool tip', 'Marquee Tool') + ' (M)', disabled: false,
        onClick: () => modes.start('marquee')
    },
    {
        name: 'Select', canFocus: true, texture: 'select',
        tip: lang.get('select tool tip', 'Select Tool') + ' (S)', disabled: false,
        onClick: () => modes.start('select')
    },
    {
        name: 'Color Select', canFocus: true, texture: 'wand',
        tip: lang.get('color select tool tip', 'Color Select Tool'), disabled: false,
        onClick: () => modes.start('wand')
    },
    {
        name: 'Bead Mode', canFocus: true, texture: 'bead_mode',
        tip: lang.get('beading tool tip', 'Beading Tool'), disabled: false,
        onClick: () => modes.start('start beading')
    },
    {
        name: 'Paint', canFocus: true, texture: 'paint',
        tip: lang.get('paint tool tip', 'Paint Tool') + ' (P)', disabled: false,
        onClick: () => modes.start('paint')
    },
    {
        name: 'Rectangle', canFocus: true, texture: 'rectangle',
        tip: lang.get('rectangle tool tip', 'Rectangle Tool') + ' (R)', disabled: false,
        onClick: () => modes.start('rectangle')
    },
    {
        name: 'Image', canFocus: true, texture: 'image',
        tip: lang.get('image tool tip', 'Image Tool'), disabled: false,
        onClick: () => modes.start('image')
    },
    {
        name: 'Mirror', canFocus: true, texture: 'mirror',
        tip: lang.get('mirror tool tip', 'Mirror Tool'), disabled: false,
        onClick: () => modes.start('mirror')
    },
    {
        name: 'Soup', canFocus: false, texture: 'soup',
        tip: lang.get('bead soup tool tip', 'Bead Soup Tool'), disabled: false,
        onClick: () => settings.toggleBeadSoup()
    },
    {
        name: 'Ruler', canFocus: false, texture: 'ruler',
        tip: lang.get('ruler tool tip', 'Ruler'), disabled: false,
        onClick: () => modes.start('ruler')
    },
    {
        name: 'Eyedropper', canFocus: false, texture: 'eyedropper',
        tip: lang.get('eyedropper tool tip', 'Eyedropper'), disabled: false,
        onClick: () => modes.start('eyedropper')
    },
    {
        name: 'Row Shift', canFocus: false, texture: 'transform',
        tip: lang.get('row shift tool tip', 'Row Shift'), disabled: false,
        onClick: () => modes.start('rowshift')
    },
    {
        name: 'Star', canFocus: false, texture: 'star',
        tip: lang.get('star tool tip', 'Star'), disabled: false,
        onClick: () => {
            modes.start('draw');
            b3.store.mySet('showingPanel', 'star');
        }
    },
];

export const tools = topTools.concat(panelTools);